<template>
  <div>
    <div style="margin: 10px auto">意见箱</div>

    <el-form ref="form" :model="form" label-width="80px">

      <el-form-item label="意见">
        <el-input v-model="form.sug" type="textarea" autosize></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="open">提交</el-button>
      </el-form-item>
    </el-form>

  </div>


</template>

<script>
import axios from '@/utils/request'

export default {
  name: 'Home',
  data() {
    return {
      form: {
        sug: ""
      }
    }
  },
  methods: {

    open() {
      this.$confirm('确认提交建议吗?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        this.onSubmit()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    onSubmit() {
      axios.post("/newSuggestion", {
        Opinion: this.form.sug
      }).then(() => {
        this.form.sug = "（已提交） " + this.form.sug
      })
    }
  },
  mounted() {

  },
  created() {
  }

}
</script>

<style scoped>
img {
  margin: 0;
  padding: 0;
}


.card {
  width: 80%;
  text-align: center;
  margin: 10px auto;
  font-family: "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}


</style>
